import React, { Component } from 'react'

import { withRouter } from 'react-router'
import { readNotificationsCurrent } from '../../utilities/notifications'

class AlertNotification extends Component {

  onClickNotificiations = (e) => {
    e.preventDefault();
    this.props.history.push(`/account/notifications`)
  }

  render() {
    return (
      <button className="alert alert--notification" onClick={this.onClickNotificiations}>
        {this.props.children}
      </button>
    );
  }
}

export default withRouter(AlertNotification);



// WEBPACK FOOTER //
// ./src/app/components/alerts/alert-notification.jsx